import React from 'react';
import { Button } from '@/components/shadcn/button';
import { Frame } from '@/types/location';
import { ignoreCoverage } from '@/legacy/api/coverage';

interface Props {
  quarantined: string[];
  setQuarantined: React.Dispatch<React.SetStateAction<string[]>>;
  activeSequence: Frame[];
  activeFrameIndex: number;
}

export default function Quarantine({
  quarantined,
  setQuarantined,
  activeSequence,
  activeFrameIndex,
}: Props) {
  const { sequence } = activeSequence[activeFrameIndex];

  const optimisticallyQuarantine = async (id: string) => {
    ignoreCoverage(id, true);
  };

  return (
    <Button
      variant="destructive"
      size={'sm'}
      disabled={quarantined.includes(sequence)}
      className="w-32"
      onClick={() => {
        setQuarantined(prev => [...prev, sequence]);
        optimisticallyQuarantine(sequence);
      }}>
      {`Quarantine${quarantined.includes(sequence) ? 'd' : ''}`}
    </Button>
  );
}
